import React from 'react'
import './style.css'

const CtaSection = (props) => {
    // Contact information
    const contactInfo = {
        phone: '+919000012345',
        email: 'nardhanamala@gmail.com',
        formattedPhone: '+91 90000 12345'
    }

    // Handler functions
    const handlePhoneClick = () => {
        window.open(`tel:${contactInfo.phone}`)
    }

    const handleEmailClick = () => {
        window.open(`mailto:${contactInfo.email}`)
    }

    return (
        <div 
            className="cta-area" 
            style={{
                paddingTop: '0', 
                paddingBottom: '0', 
                marginTop: '0', 
                marginBottom: '0'
            }}
        >
            <div className="container py-3">
                <div className="row align-items-center">
                    
                    {/* Left Section */}
                    <div className="col-lg-5 col-md-12 col-12">
                        <div className="cta-left" style={{ marginBottom: 0 }}>
                            <h2 style={{ marginBottom: '8px' }}>
                                Support the Future of Performing Arts!
                            </h2>
                            <p style={{ marginBottom: 0 }}>
                                Join <strong>Nardhanamala Foundation</strong> in nurturing talent, preserving traditions,
                                and inspiring young minds through the power of dance and music.
                            </p>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="col-lg-6 offset-lg-1 col-md-12 col-12">
                        <div 
                            className="cta-wrap d-flex justify-content-between align-items-center" 
                            style={{ margin: 0, padding: 0 }}
                        >
                            <div 
                                className="cta-call text-center mr-4" 
                                style={{ margin: 0, cursor: 'pointer' }}
                                onClick={handlePhoneClick}
                                title="Click to call"
                            >
                                <span>Reach Us</span>
                                <h3 style={{ margin: 0 }}>{contactInfo.formattedPhone}</h3>
                            </div>
                            <div 
                                className="cta-call text-center" 
                                style={{ margin: 0, cursor: 'pointer' }}
                                onClick={handleEmailClick}
                                title="Click to email"
                            >
                                <span>Drop a Mail</span>
                                <h3 style={{ margin: 0 }}>{contactInfo.email}</h3>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CtaSection